"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = exports.RoleType = exports.AppConfig = exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["TeamPoint"] = "teamPoint";
    NoteType["CreateTeam"] = "createTeam";
    NoteType["DeleteTeam"] = "deleteTeam";
    NoteType["UpdateTeam"] = "updateTeam";
    NoteType["CreateYouthKid"] = "createYouthKid";
    NoteType["UpdateYouthKid"] = "updateYouthKid";
    NoteType["DeleteYouthKid"] = "deleteYouthKid";
    NoteType["SetAppConfig"] = "setAppConfig";
})(NoteType || (exports.NoteType = NoteType = {}));
var AppConfig;
(function (AppConfig) {
    AppConfig["AppCode"] = "appCode";
})(AppConfig || (exports.AppConfig = AppConfig = {}));
var RoleType;
(function (RoleType) {
    RoleType["Developer"] = "developer";
    RoleType["Admin"] = "admin";
})(RoleType || (exports.RoleType = RoleType = {}));
var Platform;
(function (Platform) {
    Platform["IOS"] = "ios";
    Platform["Android"] = "android";
    Platform["Web"] = "web";
})(Platform || (exports.Platform = Platform = {}));
